import {pxToRem} from '../../../utills/pxToRem'

export default {
    baseStyle: {
        container: {
            minWidth: 'xs',
            width: 'full',
            boxShadow: 'base',
            fontSize: pxToRem(28),
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        },
        content: {
            maxWidth: pxToRem(1400),
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: [1.5, 1.5, 8, 8]
        },
        searchContainer: {
            order: [2, 2, 2, 'inherit'],
            width: ['full', 'full', 'full', 'full'],
            marginRight: [0, 0, 0, 0],
            marginBottom: [0, 0, 0, 0]
        },
        bodyContainer: {
            marginLeft: [2, 2, 0, 0]
        },
        logo: {
            height: [5, 5, 8, 8],
            width: [pxToRem(94), pxToRem(94), pxToRem(148), pxToRem(148)]
        },
        logoIcon: {
            marginLeft: [2, 2, 6, 6],
            height: '100%'
        },
        icons: {
            minWidth: ['0px', '0px', 10, 10],
            height: [5, 5, 8, 8]
        },
        hamburgerIcon: {
            width: [5, 5, 10, 10],
            height: [5, 5, 8, 8]
        },
        storeLocatorIcon: {
            width: [pxToRem(25), pxToRem(25), pxToRem(25), pxToRem(25)],
            height: [pxToRem(25), pxToRem(25), pxToRem(25), pxToRem(25)]
        },
        accountIcon: {
            width: [5, 5, 10, 10],
            height: [5, 5, 8, 8]
        },
        backetIcon: {
            marginRight: pxToRem(16)
        },
        account: {
            height: 11,
            minWidth: 'auto',
            cursor: 'pointer',
            alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            }
        },
        arrowDown: {
            height: 11,
            minWidth: 'auto',
            marginRight: 0,
            alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
            cursor: 'pointer',
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            },
            display: ['none', 'none', 'none', 'block']
        },
        signout: {
            width: '100%',
            borderRadius: '4px',
            height: 11,
            padding: 4,
            py: 3,
            marginTop: 1,
            _hover: {
                background: 'gray.50'
            }
        },
        signoutText: {
            fontSize: 'sm',
            fontWeight: 'normal'
        },
        signoutIcon: {
            marginRight: 2
        }
    },
    parts: [
        'container',
        'content',
        'searchContainer',
        'bodyContainer',
        'logo',
        'logoIcon',
        'icons',
        'accountIcon',
        'storeLocatorIcon',
        'basket',
        'hamburgerIcon',
        'signout'
    ]
}
